<div class="container-fluid">
  <div class="row">
    <div class="col-xl-4 col-lg-3"></div>
    <div class="col-xl-4 col-lg-6">
      <div class="row">
        <div class="col-12">
          <div class="card mb-3">
            <div class="card-header">
              <fa-icon [icon]="['fas', 'cog']" size="lg" class="mr-2" [fixedWidth]="true"></fa-icon>ADMIN - Logga in som annan person
            </div>
            <div class="card-body">
              <form [formGroup]="loginForm">
                <div class="form-group">
                  <label for="personal_number">Personnummer</label>
                  <div class="input-group mb-3">
                    <div class="input-group-prepend">
                      <span class="input-group-text">
                        <fa-icon [icon]="['fas', 'passport']" transform="grow-6" [fixedWidth]="true"></fa-icon>
                      </span>
                    </div>
                    <input type="text" name="personal_number" id="personal_number" class="form-control rounded-right" [attr.placeholder]="'placeholder.personnr' | translate" formControlName="personal_number" [class.is-invalid]="personal_number.dirty && personal_number.invalid">
                    <div class="invalid-tooltip">
                      <span *ngIf="personal_number.errors?.isEmpty">{{ 'label.ogiltigt-personnr-tomt' | translate }}</span>
                      <span *ngIf="personal_number.errors?.invalidBirthday">{{ 'label.ogiltigt-personnr-fodelsedag' | translate }}</span>
                      <span *ngIf="personal_number.errors?.invalidFormat">{{ 'label.ogiltigt-personnr-format' | translate }}</span>
                      <span *ngIf="personal_number.errors?.invalidCheckDigit">{{ 'label.ogiltigt-personnr-checksiffra' | translate }}</span>
                    </div>
                  </div>
                </div>
                <div class="form-group mb-0">
                  <input class="btn-garanti btn-pink btn-block" type="button" value="Logga in med mobilt BankID (QR-kod)" (click)="loginMobileBankId()" [disabled]="loginForm.invalid" />
                  <input class="btn-garanti btn-pink btn-block" type="button" value="Logga in med BankID på fil" (click)="loginBankIdOnFile()" [disabled]="loginForm.invalid" />
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
